/* tslint:disable */
/* eslint-disable */
/**
 * mindd-payhub-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContractPriceAdjustRequest } from '../model';
// @ts-ignore
import type { ContractUsageRecordDto } from '../model';
// @ts-ignore
import type { Dto } from '../model';
// @ts-ignore
import type { InvoiceCreateRequest } from '../model';
// @ts-ignore
import type { InvoiceDto } from '../model';
// @ts-ignore
import type { InvoiceFilterResponse } from '../model';
// @ts-ignore
import type { InvoicePage } from '../model';
// @ts-ignore
import type { SessionUsageRecordDto } from '../model';
// @ts-ignore
import type { SurveyUsageRecordDto } from '../model';
// @ts-ignore
import type { UpdateUsageRecordAmountRequest } from '../model';
// @ts-ignore
import type { UsageRecordAmountAdjustmentDto } from '../model';
// @ts-ignore
import type { WaiveRequest } from '../model';
/**
 * InvoiceApi - axios parameter creator
 * @export
 */
export const InvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 계약 요금 가격 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {number} contractId 
         * @param {ContractPriceAdjustRequest} contractPriceAdjustRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustContractFeePrice: async (invoiceId: string, contractId: number, contractPriceAdjustRequest: ContractPriceAdjustRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('adjustContractFeePrice', 'invoiceId', invoiceId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adjustContractFeePrice', 'contractId', contractId)
            // verify required parameter 'contractPriceAdjustRequest' is not null or undefined
            assertParamExists('adjustContractFeePrice', 'contractPriceAdjustRequest', contractPriceAdjustRequest)
            const localVarPath = `/api/v1/invoices/{invoiceId}/contract-fees/{contractId}/price`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractPriceAdjustRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 수동 생성 (Y_ADMIN, Y_MANAGER)
         * @param {InvoiceCreateRequest} invoiceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice: async (invoiceCreateRequest: InvoiceCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceCreateRequest' is not null or undefined
            assertParamExists('createInvoice', 'invoiceCreateRequest', invoiceCreateRequest)
            const localVarPath = `/api/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 PDF 다운로드
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('downloadPdf', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/pdf`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              recordId 의 measurementUuid 를 기반으로 동일 measurement 의 sibling record 를             함께 EXCLUDED 처리합니다 (cascade).             - BILLED record: 기존 invoice 에서 제외 후 invoice 반환             - UNBILLED record: soft-exclude 후 DRAFT preview 반환         
         * @summary Contract 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeContractRecord: async (recordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('excludeContractRecord', 'recordId', recordId)
            const localVarPath = `/api/v1/invoices/contract-records/{recordId}/exclude`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Metered 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeMeteredRecord: async (recordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('excludeMeteredRecord', 'recordId', recordId)
            const localVarPath = `/api/v1/invoices/metered-records/{recordId}/exclude`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Package 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludePackageRecord: async (recordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('excludePackageRecord', 'recordId', recordId)
            const localVarPath = `/api/v1/invoices/package-records/{recordId}/exclude`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  ## 조회 범위 - Y-brain 직원: 전체 조직의 청구서 - 일반 사용자: 본인 조직의 청구서만  ## yearMonth 파라미터 (청구월 기준) - **지정 시**: 해당 청구월의 청구서 (사용월은 yearMonth - 1) - **미지정 시**: 전체 기간의 청구서  ## DRAFT 청구서 (예상 청구서) 아직 발행되지 않은 진행 중인 청구서는 DRAFT 상태로 함께 반환됩니다. - yearMonth 지정 시: 해당 월에 아직 청구서가 없는 경우 예상 청구서를 합산하여 반환 - yearMonth 미지정 시: 이번 달의 예상 청구서가 함께 반환  ## 상태별 필터링 BillingStatus 별 필터링은 응답을 받은 후 클라이언트에서 처리합니다. 
         * @summary 청구서 필터 조회
         * @param {string} [yearMonth] 
         * @param {FilterInvoicesSortEnum} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterInvoices: async (yearMonth?: string, sort?: FilterInvoicesSortEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/invoices/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 계약 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {number} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractFeeHistory: async (invoiceId: string, contractId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getContractFeeHistory', 'invoiceId', invoiceId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getContractFeeHistory', 'contractId', contractId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/contract-fees/{contractId}/price-history`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Scan(EEG/HRV), StimHome, StimRental 사용 기록을 단일 리스트로 통합 반환한다.             클라이언트는 응답 항목의 `source` 필드(SCAN / STIM_HOME / STIM_RENTAL) 로 섹션을 분리한다.              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 contract 사용 기록 조회 (Scan + StimHome + StimRental 통합)
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractFeeRecords: async (invoiceId: string, orgId?: number, yearMonth?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getContractFeeRecords', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/contract-fees/records`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 단건 조회
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 목록 (페이지네이션)
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (pageNumber?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 종량제 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {GetMeteredFeeHistoryServiceTypeEnum} serviceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeteredFeeHistory: async (invoiceId: string, serviceType: GetMeteredFeeHistoryServiceTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getMeteredFeeHistory', 'invoiceId', invoiceId)
            // verify required parameter 'serviceType' is not null or undefined
            assertParamExists('getMeteredFeeHistory', 'serviceType', serviceType)
            const localVarPath = `/api/v1/invoices/{invoiceId}/metered-fees/{serviceType}/price-history`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"serviceType"}}`, encodeURIComponent(String(serviceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 metered 사용 기록 조회
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeteredFeeRecords: async (invoiceId: string, orgId?: number, yearMonth?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getMeteredFeeRecords', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/metered-fees/records`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 패키지 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {GetPackageFeeHistoryServiceTypeEnum} serviceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageFeeHistory: async (invoiceId: string, serviceType: GetPackageFeeHistoryServiceTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getPackageFeeHistory', 'invoiceId', invoiceId)
            // verify required parameter 'serviceType' is not null or undefined
            assertParamExists('getPackageFeeHistory', 'serviceType', serviceType)
            const localVarPath = `/api/v1/invoices/{invoiceId}/package-fees/{serviceType}/price-history`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"serviceType"}}`, encodeURIComponent(String(serviceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 package 사용 기록 조회
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageFeeRecords: async (invoiceId: string, orgId?: number, yearMonth?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getPackageFeeRecords', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/package-fees/records`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 사용 기록 amount 조정 이력 조회 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageRecordAmountHistory: async (recordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('getUsageRecordAmountHistory', 'recordId', recordId)
            const localVarPath = `/api/v1/invoices/usage-records/{recordId}/amount-history`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Contract 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeContractRecord: async (recordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('includeContractRecord', 'recordId', recordId)
            const localVarPath = `/api/v1/invoices/contract-records/{recordId}/include`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Metered 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeMeteredRecord: async (recordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('includeMeteredRecord', 'recordId', recordId)
            const localVarPath = `/api/v1/invoices/metered-records/{recordId}/include`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Package 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includePackageRecord: async (recordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('includePackageRecord', 'recordId', recordId)
            const localVarPath = `/api/v1/invoices/package-records/{recordId}/include`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Contract 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideContractRecordAmount: async (recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('overrideContractRecordAmount', 'recordId', recordId)
            // verify required parameter 'updateUsageRecordAmountRequest' is not null or undefined
            assertParamExists('overrideContractRecordAmount', 'updateUsageRecordAmountRequest', updateUsageRecordAmountRequest)
            const localVarPath = `/api/v1/invoices/contract-records/{recordId}/amount`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUsageRecordAmountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Metered 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideMeteredRecordAmount: async (recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('overrideMeteredRecordAmount', 'recordId', recordId)
            // verify required parameter 'updateUsageRecordAmountRequest' is not null or undefined
            assertParamExists('overrideMeteredRecordAmount', 'updateUsageRecordAmountRequest', updateUsageRecordAmountRequest)
            const localVarPath = `/api/v1/invoices/metered-records/{recordId}/amount`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUsageRecordAmountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Package 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overridePackageRecordAmount: async (recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('overridePackageRecordAmount', 'recordId', recordId)
            // verify required parameter 'updateUsageRecordAmountRequest' is not null or undefined
            assertParamExists('overridePackageRecordAmount', 'updateUsageRecordAmountRequest', updateUsageRecordAmountRequest)
            const localVarPath = `/api/v1/invoices/package-records/{recordId}/amount`
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUsageRecordAmountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 현재 데이터 기준 재계산 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebill: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('rebill', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/rebill`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 청구 면제 처리 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {WaiveRequest} [waiveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waive: async (invoiceId: string, waiveRequest?: WaiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('waive', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/waive`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceApi - functional programming interface
 * @export
 */
export const InvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 계약 요금 가격 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {number} contractId 
         * @param {ContractPriceAdjustRequest} contractPriceAdjustRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustContractFeePrice(invoiceId: string, contractId: number, contractPriceAdjustRequest: ContractPriceAdjustRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustContractFeePrice(invoiceId, contractId, contractPriceAdjustRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.adjustContractFeePrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 수동 생성 (Y_ADMIN, Y_MANAGER)
         * @param {InvoiceCreateRequest} invoiceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoice(invoiceCreateRequest: InvoiceCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoice(invoiceCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.createInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 PDF 다운로드
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPdf(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPdf(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.downloadPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              recordId 의 measurementUuid 를 기반으로 동일 measurement 의 sibling record 를             함께 EXCLUDED 처리합니다 (cascade).             - BILLED record: 기존 invoice 에서 제외 후 invoice 반환             - UNBILLED record: soft-exclude 후 DRAFT preview 반환         
         * @summary Contract 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async excludeContractRecord(recordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.excludeContractRecord(recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.excludeContractRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Metered 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async excludeMeteredRecord(recordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.excludeMeteredRecord(recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.excludeMeteredRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Package 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async excludePackageRecord(recordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.excludePackageRecord(recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.excludePackageRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  ## 조회 범위 - Y-brain 직원: 전체 조직의 청구서 - 일반 사용자: 본인 조직의 청구서만  ## yearMonth 파라미터 (청구월 기준) - **지정 시**: 해당 청구월의 청구서 (사용월은 yearMonth - 1) - **미지정 시**: 전체 기간의 청구서  ## DRAFT 청구서 (예상 청구서) 아직 발행되지 않은 진행 중인 청구서는 DRAFT 상태로 함께 반환됩니다. - yearMonth 지정 시: 해당 월에 아직 청구서가 없는 경우 예상 청구서를 합산하여 반환 - yearMonth 미지정 시: 이번 달의 예상 청구서가 함께 반환  ## 상태별 필터링 BillingStatus 별 필터링은 응답을 받은 후 클라이언트에서 처리합니다. 
         * @summary 청구서 필터 조회
         * @param {string} [yearMonth] 
         * @param {FilterInvoicesSortEnum} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterInvoices(yearMonth?: string, sort?: FilterInvoicesSortEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceFilterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterInvoices(yearMonth, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.filterInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 계약 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {number} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractFeeHistory(invoiceId: string, contractId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractFeeHistory(invoiceId, contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getContractFeeHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Scan(EEG/HRV), StimHome, StimRental 사용 기록을 단일 리스트로 통합 반환한다.             클라이언트는 응답 항목의 `source` 필드(SCAN / STIM_HOME / STIM_RENTAL) 로 섹션을 분리한다.              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 contract 사용 기록 조회 (Scan + StimHome + StimRental 통합)
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractUsageRecordDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractFeeRecords(invoiceId, orgId, yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getContractFeeRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 단건 조회
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoice(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoice(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 목록 (페이지네이션)
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicePage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(pageNumber, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 종량제 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {GetMeteredFeeHistoryServiceTypeEnum} serviceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeteredFeeHistory(invoiceId: string, serviceType: GetMeteredFeeHistoryServiceTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeteredFeeHistory(invoiceId, serviceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getMeteredFeeHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 metered 사용 기록 조회
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeteredFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyUsageRecordDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeteredFeeRecords(invoiceId, orgId, yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getMeteredFeeRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 패키지 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {GetPackageFeeHistoryServiceTypeEnum} serviceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackageFeeHistory(invoiceId: string, serviceType: GetPackageFeeHistoryServiceTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackageFeeHistory(invoiceId, serviceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getPackageFeeHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 package 사용 기록 조회
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackageFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionUsageRecordDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackageFeeRecords(invoiceId, orgId, yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getPackageFeeRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 사용 기록 amount 조정 이력 조회 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageRecordAmountHistory(recordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UsageRecordAmountAdjustmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageRecordAmountHistory(recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.getUsageRecordAmountHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Contract 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async includeContractRecord(recordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.includeContractRecord(recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.includeContractRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Metered 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async includeMeteredRecord(recordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.includeMeteredRecord(recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.includeMeteredRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Package 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async includePackageRecord(recordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.includePackageRecord(recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.includePackageRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Contract 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideContractRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideContractRecordAmount(recordId, updateUsageRecordAmountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.overrideContractRecordAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Metered 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideMeteredRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideMeteredRecordAmount(recordId, updateUsageRecordAmountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.overrideMeteredRecordAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Package 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overridePackageRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overridePackageRecordAmount(recordId, updateUsageRecordAmountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.overridePackageRecordAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 현재 데이터 기준 재계산 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebill(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebill(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.rebill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 청구 면제 처리 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {WaiveRequest} [waiveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waive(invoiceId: string, waiveRequest?: WaiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waive(invoiceId, waiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.waive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceApi - factory interface
 * @export
 */
export const InvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary 계약 요금 가격 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {number} contractId 
         * @param {ContractPriceAdjustRequest} contractPriceAdjustRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustContractFeePrice(invoiceId: string, contractId: number, contractPriceAdjustRequest: ContractPriceAdjustRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.adjustContractFeePrice(invoiceId, contractId, contractPriceAdjustRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 수동 생성 (Y_ADMIN, Y_MANAGER)
         * @param {InvoiceCreateRequest} invoiceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice(invoiceCreateRequest: InvoiceCreateRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.createInvoice(invoiceCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 PDF 다운로드
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf(invoiceId: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadPdf(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         *              recordId 의 measurementUuid 를 기반으로 동일 measurement 의 sibling record 를             함께 EXCLUDED 처리합니다 (cascade).             - BILLED record: 기존 invoice 에서 제외 후 invoice 반환             - UNBILLED record: soft-exclude 후 DRAFT preview 반환         
         * @summary Contract 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeContractRecord(recordId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.excludeContractRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Metered 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeMeteredRecord(recordId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.excludeMeteredRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Package 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludePackageRecord(recordId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.excludePackageRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         *  ## 조회 범위 - Y-brain 직원: 전체 조직의 청구서 - 일반 사용자: 본인 조직의 청구서만  ## yearMonth 파라미터 (청구월 기준) - **지정 시**: 해당 청구월의 청구서 (사용월은 yearMonth - 1) - **미지정 시**: 전체 기간의 청구서  ## DRAFT 청구서 (예상 청구서) 아직 발행되지 않은 진행 중인 청구서는 DRAFT 상태로 함께 반환됩니다. - yearMonth 지정 시: 해당 월에 아직 청구서가 없는 경우 예상 청구서를 합산하여 반환 - yearMonth 미지정 시: 이번 달의 예상 청구서가 함께 반환  ## 상태별 필터링 BillingStatus 별 필터링은 응답을 받은 후 클라이언트에서 처리합니다. 
         * @summary 청구서 필터 조회
         * @param {string} [yearMonth] 
         * @param {FilterInvoicesSortEnum} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterInvoices(yearMonth?: string, sort?: FilterInvoicesSortEnum, options?: any): AxiosPromise<InvoiceFilterResponse> {
            return localVarFp.filterInvoices(yearMonth, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 계약 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {number} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractFeeHistory(invoiceId: string, contractId: number, options?: any): AxiosPromise<Array<Dto>> {
            return localVarFp.getContractFeeHistory(invoiceId, contractId, options).then((request) => request(axios, basePath));
        },
        /**
         *              Scan(EEG/HRV), StimHome, StimRental 사용 기록을 단일 리스트로 통합 반환한다.             클라이언트는 응답 항목의 `source` 필드(SCAN / STIM_HOME / STIM_RENTAL) 로 섹션을 분리한다.              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 contract 사용 기록 조회 (Scan + StimHome + StimRental 통합)
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: any): AxiosPromise<Array<ContractUsageRecordDto>> {
            return localVarFp.getContractFeeRecords(invoiceId, orgId, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 단건 조회
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice(invoiceId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.getInvoice(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 목록 (페이지네이션)
         * @param {number} [pageNumber] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(pageNumber?: number, limit?: number, options?: any): AxiosPromise<InvoicePage> {
            return localVarFp.getInvoices(pageNumber, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 종량제 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {GetMeteredFeeHistoryServiceTypeEnum} serviceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeteredFeeHistory(invoiceId: string, serviceType: GetMeteredFeeHistoryServiceTypeEnum, options?: any): AxiosPromise<Array<Dto>> {
            return localVarFp.getMeteredFeeHistory(invoiceId, serviceType, options).then((request) => request(axios, basePath));
        },
        /**
         *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 metered 사용 기록 조회
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeteredFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: any): AxiosPromise<Array<SurveyUsageRecordDto>> {
            return localVarFp.getMeteredFeeRecords(invoiceId, orgId, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 패키지 요금 가격 조정 이력 조회
         * @param {string} invoiceId 
         * @param {GetPackageFeeHistoryServiceTypeEnum} serviceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageFeeHistory(invoiceId: string, serviceType: GetPackageFeeHistoryServiceTypeEnum, options?: any): AxiosPromise<Array<Dto>> {
            return localVarFp.getPackageFeeHistory(invoiceId, serviceType, options).then((request) => request(axios, basePath));
        },
        /**
         *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
         * @summary Invoice 의 모든 package 사용 기록 조회
         * @param {string} invoiceId 
         * @param {number} [orgId] 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: any): AxiosPromise<Array<SessionUsageRecordDto>> {
            return localVarFp.getPackageFeeRecords(invoiceId, orgId, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 사용 기록 amount 조정 이력 조회 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageRecordAmountHistory(recordId: string, options?: any): AxiosPromise<Array<UsageRecordAmountAdjustmentDto>> {
            return localVarFp.getUsageRecordAmountHistory(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Contract 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeContractRecord(recordId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.includeContractRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Metered 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeMeteredRecord(recordId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.includeMeteredRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Package 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includePackageRecord(recordId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.includePackageRecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Contract 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideContractRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.overrideContractRecordAmount(recordId, updateUsageRecordAmountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Metered 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideMeteredRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.overrideMeteredRecordAmount(recordId, updateUsageRecordAmountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Package 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
         * @param {string} recordId 
         * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overridePackageRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.overridePackageRecordAmount(recordId, updateUsageRecordAmountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 현재 데이터 기준 재계산 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebill(invoiceId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.rebill(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 청구 면제 처리 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {WaiveRequest} [waiveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waive(invoiceId: string, waiveRequest?: WaiveRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.waive(invoiceId, waiveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceApi - object-oriented interface
 * @export
 * @class InvoiceApi
 * @extends {BaseAPI}
 */
export class InvoiceApi extends BaseAPI {
    /**
     * 
     * @summary 계약 요금 가격 수동 조정 (Y_ADMIN, Y_MANAGER)
     * @param {string} invoiceId 
     * @param {number} contractId 
     * @param {ContractPriceAdjustRequest} contractPriceAdjustRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public adjustContractFeePrice(invoiceId: string, contractId: number, contractPriceAdjustRequest: ContractPriceAdjustRequest, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).adjustContractFeePrice(invoiceId, contractId, contractPriceAdjustRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 수동 생성 (Y_ADMIN, Y_MANAGER)
     * @param {InvoiceCreateRequest} invoiceCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public createInvoice(invoiceCreateRequest: InvoiceCreateRequest, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).createInvoice(invoiceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 PDF 다운로드
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public downloadPdf(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).downloadPdf(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              recordId 의 measurementUuid 를 기반으로 동일 measurement 의 sibling record 를             함께 EXCLUDED 처리합니다 (cascade).             - BILLED record: 기존 invoice 에서 제외 후 invoice 반환             - UNBILLED record: soft-exclude 후 DRAFT preview 반환         
     * @summary Contract 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public excludeContractRecord(recordId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).excludeContractRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Metered 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public excludeMeteredRecord(recordId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).excludeMeteredRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Package 사용 기록 billing 제외 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public excludePackageRecord(recordId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).excludePackageRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  ## 조회 범위 - Y-brain 직원: 전체 조직의 청구서 - 일반 사용자: 본인 조직의 청구서만  ## yearMonth 파라미터 (청구월 기준) - **지정 시**: 해당 청구월의 청구서 (사용월은 yearMonth - 1) - **미지정 시**: 전체 기간의 청구서  ## DRAFT 청구서 (예상 청구서) 아직 발행되지 않은 진행 중인 청구서는 DRAFT 상태로 함께 반환됩니다. - yearMonth 지정 시: 해당 월에 아직 청구서가 없는 경우 예상 청구서를 합산하여 반환 - yearMonth 미지정 시: 이번 달의 예상 청구서가 함께 반환  ## 상태별 필터링 BillingStatus 별 필터링은 응답을 받은 후 클라이언트에서 처리합니다. 
     * @summary 청구서 필터 조회
     * @param {string} [yearMonth] 
     * @param {FilterInvoicesSortEnum} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public filterInvoices(yearMonth?: string, sort?: FilterInvoicesSortEnum, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).filterInvoices(yearMonth, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 계약 요금 가격 조정 이력 조회
     * @param {string} invoiceId 
     * @param {number} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getContractFeeHistory(invoiceId: string, contractId: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getContractFeeHistory(invoiceId, contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Scan(EEG/HRV), StimHome, StimRental 사용 기록을 단일 리스트로 통합 반환한다.             클라이언트는 응답 항목의 `source` 필드(SCAN / STIM_HOME / STIM_RENTAL) 로 섹션을 분리한다.              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
     * @summary Invoice 의 모든 contract 사용 기록 조회 (Scan + StimHome + StimRental 통합)
     * @param {string} invoiceId 
     * @param {number} [orgId] 
     * @param {string} [yearMonth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getContractFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getContractFeeRecords(invoiceId, orgId, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 단건 조회
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getInvoice(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getInvoice(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 목록 (페이지네이션)
     * @param {number} [pageNumber] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getInvoices(pageNumber?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getInvoices(pageNumber, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 종량제 요금 가격 조정 이력 조회
     * @param {string} invoiceId 
     * @param {GetMeteredFeeHistoryServiceTypeEnum} serviceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getMeteredFeeHistory(invoiceId: string, serviceType: GetMeteredFeeHistoryServiceTypeEnum, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getMeteredFeeHistory(invoiceId, serviceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
     * @summary Invoice 의 모든 metered 사용 기록 조회
     * @param {string} invoiceId 
     * @param {number} [orgId] 
     * @param {string} [yearMonth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getMeteredFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getMeteredFeeRecords(invoiceId, orgId, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 패키지 요금 가격 조정 이력 조회
     * @param {string} invoiceId 
     * @param {GetPackageFeeHistoryServiceTypeEnum} serviceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getPackageFeeHistory(invoiceId: string, serviceType: GetPackageFeeHistoryServiceTypeEnum, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getPackageFeeHistory(invoiceId, serviceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              invoiceId 가 존재하지 않을 때:             - orgId + yearMonth 파라미터 제공 시: 해당 기간의 UNBILLED 레코드 반환 (DRAFT 미리보기)             - 파라미터 없으면 빈 배열 반환         
     * @summary Invoice 의 모든 package 사용 기록 조회
     * @param {string} invoiceId 
     * @param {number} [orgId] 
     * @param {string} [yearMonth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getPackageFeeRecords(invoiceId: string, orgId?: number, yearMonth?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getPackageFeeRecords(invoiceId, orgId, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 사용 기록 amount 조정 이력 조회 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public getUsageRecordAmountHistory(recordId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).getUsageRecordAmountHistory(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Contract 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public includeContractRecord(recordId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).includeContractRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Metered 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public includeMeteredRecord(recordId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).includeMeteredRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Package 사용 기록 billing 재포함 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public includePackageRecord(recordId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).includePackageRecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Contract 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public overrideContractRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).overrideContractRecordAmount(recordId, updateUsageRecordAmountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Metered 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public overrideMeteredRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).overrideMeteredRecordAmount(recordId, updateUsageRecordAmountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Package 사용 기록 amount 수동 조정 (Y_ADMIN, Y_MANAGER)
     * @param {string} recordId 
     * @param {UpdateUsageRecordAmountRequest} updateUsageRecordAmountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public overridePackageRecordAmount(recordId: string, updateUsageRecordAmountRequest: UpdateUsageRecordAmountRequest, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).overridePackageRecordAmount(recordId, updateUsageRecordAmountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 현재 데이터 기준 재계산 (Y_ADMIN, Y_MANAGER)
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public rebill(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).rebill(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 청구 면제 처리 (Y_ADMIN, Y_MANAGER)
     * @param {string} invoiceId 
     * @param {WaiveRequest} [waiveRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public waive(invoiceId: string, waiveRequest?: WaiveRequest, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).waive(invoiceId, waiveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const FilterInvoicesSortEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterInvoicesSortEnum = typeof FilterInvoicesSortEnum[keyof typeof FilterInvoicesSortEnum];
/**
 * @export
 */
export const GetMeteredFeeHistoryServiceTypeEnum = {
    Eeg: 'EEG',
    Hrv: 'HRV',
    NeuroGuide: 'NEURO_GUIDE',
    ScanHrv: 'SCAN_HRV',
    ScanNeuroGuide: 'SCAN_NEURO_GUIDE',
    StimHome: 'STIM_HOME',
    StimRental: 'STIM_RENTAL',
    StimProRental: 'STIM_PRO_RENTAL',
    KorPsy: 'KOR_PSY',
    Inpsyt: 'INPSYT',
    SleepDiary: 'SLEEP_DIARY'
} as const;
export type GetMeteredFeeHistoryServiceTypeEnum = typeof GetMeteredFeeHistoryServiceTypeEnum[keyof typeof GetMeteredFeeHistoryServiceTypeEnum];
/**
 * @export
 */
export const GetPackageFeeHistoryServiceTypeEnum = {
    Eeg: 'EEG',
    Hrv: 'HRV',
    NeuroGuide: 'NEURO_GUIDE',
    ScanHrv: 'SCAN_HRV',
    ScanNeuroGuide: 'SCAN_NEURO_GUIDE',
    StimHome: 'STIM_HOME',
    StimRental: 'STIM_RENTAL',
    StimProRental: 'STIM_PRO_RENTAL',
    KorPsy: 'KOR_PSY',
    Inpsyt: 'INPSYT',
    SleepDiary: 'SLEEP_DIARY'
} as const;
export type GetPackageFeeHistoryServiceTypeEnum = typeof GetPackageFeeHistoryServiceTypeEnum[keyof typeof GetPackageFeeHistoryServiceTypeEnum];
